import { render } from "./KontaktaOss.vue?vue&type=template&id=37f17bef"
import script from "./KontaktaOss.vue?vue&type=script&lang=js"
export * from "./KontaktaOss.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__